<template>
  <!-- 用户评论部分 -->
  <div class="comment" v-loading="loding">
    <!-- 显示用户的评论数量 -->
    <!-- <div class="comment_num">评论（{{ mycomment.count }}）</div> -->
    <div class="comment_num">评论</div>
    <div class="edit_comment">
      <div class="edit_input_box">
        <div class="heihgt20">
          <input
            type="text"
            placeholder="写下您的评论..."
            class="comment_input"
            v-model="text"
          />
          <!-- 提示内容框 -->
          <!-- <div class="pinglunBox">{{ conment_content }}</div> -->
        </div>
        <!-- <div class="heihgt20">
          <i class="iconfont icon-tupian1"></i>
        </div> -->
      </div>
      <div class="edit_input_btn" @click="openDialog">评论</div>
      <!-- <commentDiaLog
        :share_id="share_id"
        ref="mydialog"
        @MyClose="changeComment($event)"
      ></commentDiaLog> -->
    </div>
    <!-- 评论内容框 -->
    <div>
      <commentItem
        v-for="(item, index) in mycomment.list"
        :key="index"
        :role="role"
        :oneComment="item"
        :share_id="share_id"
        :num="index + 1"
      ></commentItem>
    </div>
    <!-- 最下方页码部分如果角色为评论详情页时才显示 -->
    <div class="comment_pagination" v-show="role === 'child'">
      <el-pagination
        background
        layout="prev, pager, next"
        :total="mycomment.count"
        :page-size="pagesize"
        :current-page="mypage"
        @current-change="changepage($event)"
      >
      </el-pagination>
    </div>
    <div
      class="more"
      @click="newOpen(share_id)"
      v-if="role !== 'child' && mycomment.count > 7"
    >
      <span>查看剩余{{ mycomment.count - 7 }}条评论</span>
      <!-- <span>查看全部评论</span> -->
      <i class="iconfont icon-jiantou"></i>
    </div>
  </div>
</template>

<script>
import { mapState, mapMutations } from "vuex";
import commentItem from "./comment_child/comment_item.vue";
// import commentDiaLog from "./commentDialog.vue";
export default {
  name: "comment",
  components: {
    commentItem,
    // commentDiaLog,
  },
  props: {
    role: {
      type: String,
      default: "parent",
    },
    // 接收当前评论数据
    mycomment: {
      type: Object,
      default: () => {
        return {
          count: 2,
          list: [
            {
              reamrk_id: "0",
              avatar: "	http://localhost:8080/img/banner.7028ebf0.png",
              username: "大哥",
              content: "我是大哥，我评论了一个文章",
              praised_count: "99",
              time: "8月8日  12：30",
              children: [
                {
                  reamrk_id: "1",
                  level: "2",
                  from_user_name: "二弟",
                  to_user_name: "大哥",
                  content: "我是二弟，我评论了大哥的评论",
                  praised_count: "88",
                },
                {
                  reamrk_id: "1",
                  level: "2",
                  from_user_name: "大哥",
                  to_user_name: "二弟",
                  content: "我是大哥，我回复了二弟的评论",
                  praised_count: "77",
                },
              ],
            },
          ],
        };
      },
    },
    // 接收当前分享ID
    share_id: {
      type: Number,
      default: 2,
    },
  },
  data() {
    return {
      // dialogVisible: false,
      conment_content: "写下您的评论...",
      loding: true,
      // 每一页所展现的数据
      pagesize: 8,
      // 当前页码
      mypage: 1,
      // 评论框输入的内容
      text: "",
    };
  },
  computed: {
    ...mapState(["token", "agency_id"]),
  },
  methods: {
    ...mapMutations(["newOpen"]),
    openDialog() {
      // this.$refs.mydialog.open();
      this.UpComment();
    },
    // 监听模态输入框的内容，并展示在评论框中
    changeComment(event) {
      if (event == "") {
        this.conment_content = "写下您的评论...";
      } else {
        this.conment_content = event;
      }
    },
    // 上传评论
    UpComment() {
      this.$axios
        .get("/pushRemark", {
          params: {
            agency_id: this.agency_id,
            share_id: this.share_id,
            content: this.text,
            token: this.token,
          },
        })
        .then((doc) => {
          if (doc.code == 200) {
            doc.children = null;
            if (this.mycomment.list != null) {
              this.mycomment.list.unshift(doc);
            } else {
              this.mycomment.list = [];
              this.mycomment.list.unshift(doc);
            }
            this.text = "";
            // 强制组件刷新
            this.$forceUpdate();
            this.$message({
              message: "评论发布成功",
              type: "success",
            });
          } else {
            this.$message({
              message: doc.message,
              type: "warning",
            });
          }
        })
        .catch((err) => {
          this.$message({
            message: err.data.message,
            type: "warning",
          });
        });
    },
    // 分页
    changepage(e) {
      this.$emit("changePage", e);
    },
  },
  mounted() {
    setTimeout(() => {
      this.loding = false;
    }, 1000);
  },
  created() {
    this.$on("CUpComment", () => {
    });
  },
};
</script>

<style lang="less" scoped>
// 最下方评论部分
.comment {
  // margin-bottom: 1.5rem;
  width: 100%;
  // height: 18.75rem;
  background-color: #ffffff;

  // 最上方显示的用户评论数量
  .comment_num {
    padding: 0 2.5rem;
    height: 2.5625rem;
    line-height: 2.5625rem;
    font-size: 0.875rem;
    font-family: "Microsoft YaHei";
    font-weight: 400;
    color: #737373;
    background-color: #f6f6f6;
  }

  .comment_pagination {
    height: 3.3125rem;
    display: flex;
    align-items: center;
    justify-content: center;
    border-bottom: 0.0625rem solid #eeeeee;
    /deep/ .el-pagination {
      .el-icon-arrow-left:before {
        content: "上一页";
      }

      .el-icon-arrow-right:before {
        content: "下一页";
      }

      .el-pager li,
      .btn-prev,
      .btn-next {
        background-color: transparent;
      }
      .el-pager li.active {
        color: #c0c4cc;
      }
      // .el-icon-more {
      //   display: none;
      // }
    }
  }
  .edit_comment {
    padding: 0.6875rem 2.125rem 0.6875rem 2.5625rem;
    display: flex;
    flex-direction: row;
    justify-items: center;
    align-items: center;

    .edit_input_box {
      flex: 1;
      display: flex;
      flex-direction: row;
      justify-content: space-between;
      align-items: center;
      margin-right: 1rem;
      padding: 0 0.625rem;
      width: 33.5625rem;
      height: 2.375rem;
      background: #ffffff;
      border: 0.0625rem solid #ebebeb;
      border-radius: 0.1875rem;
      .heihgt20 {
        height: 1.25rem;
        width: 100%;
        .comment_input {
          outline: none;
          border: none;
          width: 100%;
        }
        .pinglunBox {
          width: 28.125rem;
          font-size: 0.875rem;
          font-family: "Microsoft YaHei";
          font-weight: 400;
          color: #989fac;
          overflow: hidden;
          text-overflow: ellipsis;
          white-space: nowrap;
        }
        .icon-tupian1 {
          font-size: 1.25rem;
          color: #98a2b4;
        }
      }
    }
    .edit_input_btn {
      cursor: pointer;
      width: 3.875rem;
      height: 2.375rem;
      background: #fa7d3c;
      border-radius: 0.1875rem;
      line-height: 2.375rem;
      text-align: center;
      font-size: 1rem;
      font-family: "Microsoft YaHei";
      font-weight: 400;
      color: #ffffff;
      cursor: pointer;
    }
  }
  .more {
    height: 2.5rem;
    width: 100%;
    text-align: center;
    line-height: 2.5rem;
    color: #606266;
    font-size: 0.875rem;
    cursor: pointer;
    .icon-jiantou:before {
      font-size: 0.575rem;
    }
  }
  .more:hover {
    color: #ff8673;
  }
}
</style>